import gql from 'graphql-tag'

export default gql`
  query getStoreInfo {
    getStoreInfo {
      store_id
      terms_and_conditions
      locale
    }
  }
`
